// extracted by mini-css-extract-plugin
export var addressFields = "_p2-0";
export var animationContainer = "_p2-1";
export var footer = "_p2-2";
export var lineItems = "_p2-3";
export var modalContent = "_p2-4";
export var orderName = "_p2-5";
export var strong = "_p2-6";
export var warning = "_p2-7";